import { Customer } from '@/types/Customer';
import { map } from 'lodash';
import { listBoxRadius } from 'ui';
import { IconCheck, IconChevronRight } from 'ui/Icons';
import {
  Avatar,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from 'ui/mui';
import { cardBackgroundColor } from 'ui/utils/color';

type UserListProps = {
  users: Customer[];
  selectedCustomer: Customer | null;
  setSwitchingCustomer: (customer: Customer) => void;
};

const UserList = ({
  users,
  selectedCustomer,
  setSwitchingCustomer,
}: UserListProps) => {
  function stringAvatar(name: string) {
    const nameParts = name.split(' ').filter((part) => part.trim() !== '');
    const initials = nameParts.map((part) => part[0]);
    return initials.join('');
  }
  return (
    <List>
      {map(users, (customer, index) => {
        const isCurrent =
          customer.customerId === selectedCustomer?.customerId &&
          customer?.name === selectedCustomer?.name;
        const isInactive = customer.status?.id == 2;
        return (
          <ListItemButton
            key={customer?.customerId + index}
            onClick={() => {
              setSwitchingCustomer(customer);
            }}
            selected={isCurrent}
            sx={(theme) => ({
              borderLeft: '4px solid transparent',
              background: theme.palette.background.default,
              mb: '2px',
              borderRadius: listBoxRadius,
              '&.Mui-selected, &:hover, &:active, &.Mui-focusVisible': {
                borderLeftColor: theme.palette.accent.main,
                background: theme.palette.background.default,
              },
              '&:hover .MuiListItemIcon-root .MuiAvatar-root, &:focus .MuiListItemIcon-root .MuiAvatar-root':
                {
                  color: theme.palette.background.default,
                  background: theme.palette.primary.main,
                },
            })}
          >
            <ListItemIcon>
              <Avatar
                sx={(theme) => ({
                  fontSize: 16,
                  color: isCurrent ? 'primary.contrast' : 'primary.main',
                  background: isCurrent
                    ? theme.palette.primary.main
                    : cardBackgroundColor(theme),
                })}
              >
                {isCurrent ? <IconCheck /> : stringAvatar(customer.name)}
              </Avatar>
            </ListItemIcon>
            <ListItemText
              sx={{ textTransform: 'capitalize' }}
              secondary={isInactive && 'inaktiv'}
            >
              {typeof customer?.name === 'string'
                ? customer?.name?.toLowerCase()
                : customer?.name}
            </ListItemText>
            <IconChevronRight
              sx={(theme) => ({
                color: theme.palette.action.active,
              })}
            />
          </ListItemButton>
        );
      })}
    </List>
  );
};

export default UserList;
